import axios from 'axios';
import country from '@/mixins/country.js';
import csvtojson from 'csvtojson';
import { getCountries } from '@/api/countries';
export default {
	mixins: [country],
	methods: {
		async csvToJson(input) {
			let data = await csvtojson({ delimiter: ',' })
				.fromString(input)
				.then((json) => {
					return json;
				});
			return data;
		},

		async loadData() {
			this.$store.commit('setAllDataLoaded', false);
			const hierarchy = await axios.get('/data/hierarchy.json?v=' + Date.now()).then((res) => res.data);
			// console.log(JSON.parse(hierarchy));
			this.$store.commit('setHierarchy', hierarchy);
			const countries = await getCountries().then((res) => res.data);
			this.$store.commit('setCountries', countries);
			this.$store.commit('setAllDataLoaded', true);
		},
	},
};
